export default {
  // EXAMPLE_ACTION_TYPE: "[module] Example Action Type",

  GET_ENTERPRISE_LEADS_REQUEST: "[enterpriseLeads] GET Enterprise Leads",
  SET_ENTERPRISE_LEADS: "[enterpriseLeads] SET Enterprise Leads",
  // INSERTION_PT (for script, do not remove)
};
